document.querySelectorAll('.modal-trigger').forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    const modalId = el.getAttribute('data-modal-id');
    const modal = document.querySelector(`#${modalId}`);

    // save trigger to modal
    modal.setAttribute('data-trigger-id', el.id);

    modal.classList.add('modal--active');

    modal.addEventListener('click', (e) => {
      e.preventDefault();
      modal.classList.remove('modal--active');

      // move focus back to trigger
      const triggerId = modal.getAttribute('data-trigger-id');
      const trigger = document.querySelector(`#${triggerId}`);

      trigger.focus();
    });
  });
});

// esc key closes any open modal
document.addEventListener('keyup', (e) => {
  if (e.key === 'Escape') {
    document.querySelectorAll('.modal--active').forEach((el) => {
      el.classList.remove('modal--active');

      // move focus back to trigger
      const triggerId = modal.getAttribute('data-trigger-id');
      const trigger = document.querySelector(`#${triggerId}`);

      trigger.focus();
    });
  }
});

// close modal
document.querySelectorAll('.modal__close').forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    const modal = el.closest('.modal');
    modal.classList.remove('modal--active');

    // move focus back to trigger
    const triggerId = modal.getAttribute('data-trigger-id');
    const trigger = document.querySelector(`#${triggerId}`);

    trigger.focus();
  });
});
